module.exports = __webpack_public_path__ + "static/media/gg_rotate_finger.139633df.gif";